import { DistributionConsumer } from '@injectivelabs/chain-consumer'
import { app } from './App'

export const distributionConsumer = new DistributionConsumer(
  app.appUrlEndpoint.chainUrl
)
